import styled from "styled-components";
import { barriosPorDepartamento } from "../../data/barriosMendoza";
import { departamentosMendoza, normalizeTerritory, officialTerritorySource } from "../../data/departamentosMendoza";

function BarrioInfo({ barrio, department, province }) {

  if (!barrio) {
    return (
      <Wrapper>
        <Title>Barrio no disponible</Title>
      </Wrapper>
    );
  }

  // soporta string o objeto
  const barrioNombre =
    typeof barrio === "string" ? barrio : barrio?.name || "";

  const normalized = normalizeTerritory(barrioNombre
    .replace("sección 5ª", "quinta_seccion")
    .replace("seccion 5ª", "quinta_seccion")
    .replace("residencial sur", "residencial_sur"));
  const normalizedDepartment = normalizeTerritory(
    department || (typeof barrio === "object" ? barrio?.department : "")
  );
  // El catálogo curado actual corresponde exclusivamente a Mendoza. Algunos
  // departamentos comparten nombre con otras provincias (por ejemplo Junín),
  // por lo que nunca debe inferirse Mendoza a partir del departamento.
  const isMendoza = !province || normalizeTerritory(province).replace(/\s+/g, '_') === 'mendoza';

  let barrioCurado = null;

  for (const depto in (isMendoza ? barriosPorDepartamento : {})) {
    if (normalizedDepartment && normalizeTerritory(depto) !== normalizedDepartment) continue;
    const encontrado = barriosPorDepartamento[depto].find((b) => b.id === normalized);

    if (encontrado) {
      barrioCurado = encontrado;
      break;
    }
  }

  const departmentProfile = isMendoza ? departamentosMendoza[normalizedDepartment] : null;
  const profile = barrioCurado || departmentProfile;

  if (!profile) {
    return (
      <Wrapper>
        <Title>Sobre {barrioNombre}</Title>
        <Description>
          Explorá el mapa y los lugares cercanos para conocer los servicios y puntos de interés de esta zona.
        </Description>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Eyebrow>{barrioCurado ? 'IDENTIDAD LOCAL' : `CONTEXTO · ${departmentProfile.name}`}</Eyebrow>
      <Title>Sobre {barrioNombre || profile.name}</Title>

      {profile.description && (
        <Description>{profile.description}</Description>
      )}

      {(profile.highlights || profile.landmarks)?.length > 0 && (
        <>
        <Subheading>Referentes de la zona</Subheading>
        <Highlights>
          {(profile.highlights || profile.landmarks).map((item, index) => (
            <Highlight key={index}>{item}</Highlight>
          ))}
        </Highlights>
        </>
      )}

      {profile.tags?.length > 0 && (
        <Tags>
          {profile.tags.map((tag, index) => (
            <Tag key={index}>{tag}</Tag>
          ))}
        </Tags>
      )}

      {barrioCurado?.photos?.length > 0 && (
        <Gallery>
          {barrioCurado.photos.map((photo, index) => (
            <img key={index} src={photo} alt={barrioCurado.name} />
          ))}
        </Gallery>
      )}
      {departmentProfile && <Source href={officialTerritorySource} target="_blank" rel="noreferrer">Conocer el departamento en la fuente oficial ↗</Source>}
    </Wrapper>
  );
}

export default BarrioInfo;


/* estilos */

const Wrapper = styled.div`
  margin-top: 16px;
`;
const Eyebrow = styled.div`margin-bottom:10px;color:#b45f40;font-size:12px;font-weight:750;letter-spacing:.16em;`;

const Title = styled.h3`
  font-size: 22px;
  margin-bottom: 16px;
`;

const Description = styled.p`
  max-width:760px;color:#68777b;line-height:1.7;
  margin-bottom: 20px;
`;
const Subheading = styled.h4`margin:28px 0 13px;font-size:14px;`;

const Highlights = styled.ul`
  margin-bottom: 20px;
  padding-left: 18px;
`;

const Highlight = styled.li`
  margin-bottom: 8px;color:#405a61;
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
`;

const Tag = styled.span`
  color:#29474f;background: #edf0ec;
  padding: 7px 11px;
  border-radius: 999px;
  font-size: 13px;
`;
const Source = styled.a`display:inline-flex;margin-top:6px;color:#29474f;font-size:12px;font-weight:650;text-decoration:none;border-bottom:1px solid #b45f40;`;

const Gallery = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;

  img {
    width: 100%;
    border-radius: 6px;
    object-fit: cover;
  }
`;
